import { Button, Container, Card } from 'react-angle-dashboard-components'
import { StylesConfig } from 'react-select'
import styled from 'styled-components'

export const StyledBackground = styled.div`
  width: 100%;
  height: 350px;
  @media (max-width: 767px) {
    height: 200px;
  }
`

export const StyledCard = styled(Card)`
  background: #f3effc;
  padding: 0 1rem;
  border-radius: 10px;
  margin: 60px 0 50px 0;
  min-width: 345px;
  @media (max-width: 767px) {
    padding: 0;
    margin-top: 50px;
  }
`

export const CardFirstHalf = styled.div`
  width: 65%;
  margin-right: 1rem;
  @media (max-width: 767px) {
    width: 100%;
    margin-right: 0;
  }
`

export const CardSecondHalf = styled.div`
  width: 35%;
  @media (max-width: 767px) {
    width: 100%;
  }
`

export const StyledH1 = styled.h1`
  font-size: 40px;
  font-family: 'Sentinel';
`

export const StyledContainer = styled(Container)`
  position: relative;
  margin-top: -160px;
  max-width: 1000px;
  @media (max-width: 767px) {
    margin-top: 0;
  }
`

export const CareContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 2rem;
  min-width: 345px;
  @media (max-width: 767px) {
    padding: 0;
    border-radius: 0;
  }
`

export const SearchWrapper = styled.div`
  border: 1px solid #e7eaf3;
  border-radius: 6px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
`

export const SuggestionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Suggestion = styled.div`
  padding: 8px 12px;
  border: 1px solid #e7eaf3;
  border-radius: 6px;
  margin-top: 0.6rem;
  margin-right: 0.6rem;
  &:hover {
    cursor: pointer;
    background: #f2f7f8;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const SearchOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.325rem;

  > div {
    display: flex;
    flex-direction: column;

    h6 {
      font-weight: normal;
      margin-bottom: 2px;
      text-transform: capitalize;
    }

    p {
      margin-bottom: 0;
      font-size: 14px;
    }
  }
`

export const SelectedSearchOption = styled(SearchOption)`
  padding: 0;
  div.avatar {
    margin-right: 0.5rem !important;
    width: 32px !important;
    height: 32px !important;
  }

  > div {
    > p {
      font-size: 16px;
    }
  }
`

export const StyledButton = styled(Button)<{ disabled: boolean }>`
  height: 46px;
  padding: 8px 16px;
  background: #237d83 !important;
  border: none;
  border-radius: 4.8px;
  ${(props) =>
    !props.disabled &&
    `&:hover {
    opacity: 0.8;
  }`}
`

export const AvatarContainer = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #d5f1f3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.8rem;
`

export const SeachContainer = styled.div<{ isFocused: boolean }>`
  width: 60%;
  height: 100%;
  border-top-left-radius: 6px;
  border: ${(props) => (props.isFocused ? '1px solid #237D83' : 'none')};
  border-right: ${(props) =>
    props.isFocused ? '1px solid #237D83' : '1px solid #e7eaf3'};
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
`

export const LocationContainer = styled.div<{
  hasError: boolean
  isFocused: boolean
}>`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  flex-grow: 1;
  border-top-right-radius: 6px;
  border: ${(props) =>
    props.hasError
      ? '1px solid red'
      : props.isFocused
      ? '1px solid #237D83'
      : 'none'};
`

export const getSelectStyles = (
  searchWrapperRef: React.RefObject<HTMLDivElement>
): StylesConfig<any, any, any> => {
  return {
    control: (provided) => ({
      ...provided,
      border: 'none',
      // Remove blue border when focused
      boxShadow: 'none'
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: 'visible',
      // Space for absolute positioned search icon
      marginLeft: '2rem'
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '1rem',
      width: searchWrapperRef.current?.clientWidth || 'initial'
    }),
    option: (provided, { isSelected }) => ({
      ...provided,
      background: isSelected ? '#F2F7F8' : ''
    }),
    input: (provided) => ({
      ...provided,
      // Avoid transparent text color when selecting an option
      input: {
        opacity: '1 !important'
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      textOverflow: 'ellipsis',
      width: '100%',
      paddingRight: '1rem',
      whiteSpace: 'nowrap',
      overflowX: 'hidden'
    })
  }
}
